import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../../../components/common/Snackbar';
import { SSO_LOGOUT_URL } from '../../../constants/mainLayout';

/**
 * Hook to manage logout logic for MainLayout component
 * @param {Function} logout - Logout function from auth context
 * @returns {Function} Logout handler
 */
export const useMainLayoutLogout = (logout) => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleLogout = async () => {
    try {
      await logout();
      showSnackbar('Logged out successfully', 'success');
      
      // Try to redirect to external SSO portal
      // If the external portal has issues, user will see the error page
      // but local session is already cleared
      try {
        window.location.href = SSO_LOGOUT_URL;
      } catch (redirectError) {
        // If redirect fails, just stay on login page
        navigate('/login');
      }
    } catch (error) {
      // console.error('Logout error:', error);
      showSnackbar('Failed to logout. Please try again.', 'error');
    }
  };

  return {
    handleLogout,
  };
};
